import { createContext, type ReactNode, useContext, useEffect, useState } from 'react'

interface AdminPageHeaderState {
  title?: string
  subtitle?: string
}

interface AdminPageHeaderContextValue extends AdminPageHeaderState {
  setHeader: (state: AdminPageHeaderState) => void
}

const AdminPageHeaderContext = createContext<AdminPageHeaderContextValue | null>(null)

export function AdminPageHeaderProvider({ children }: { children: ReactNode }) {
  const [header, setHeader] = useState<AdminPageHeaderState>({})
  return (
    <AdminPageHeaderContext.Provider value={{ ...header, setHeader }}>
      {children}
    </AdminPageHeaderContext.Provider>
  )
}

export function useAdminPageHeader() {
  const ctx = useContext(AdminPageHeaderContext)
  if (!ctx) return { title: undefined, subtitle: undefined }
  return ctx
}

export function useSetAdminPageHeader(title?: string, subtitle?: string) {
  const ctx = useContext(AdminPageHeaderContext)
  useEffect(() => {
    if (!ctx) return
    ctx.setHeader({ title, subtitle })
    return () => ctx.setHeader({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, subtitle])
}
